module.exports = __webpack_public_path__ + "img/DW365-188.e40344c1.jpg";